import styled from 'styled-components'

export const Divider = styled.div`
  margin: var(--space-100) 0;
  padding: 0;
  border-bottom: 1px solid var(--bg-tertiary);
`
